import { FilterType, Filter, FilterKey } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '../../types';

const key = FilterKey.FACULTY;
export const getFacultyFilter = ({ activeFilters, filterOptions }: IGetFilterGroupsProps): Filter | null => {
  const filters = activeFilters[key] ?? [];
  const faculties = filterOptions?.faculty ?? [];
  const options = faculties?.map((faculty: any) => {
    return {
      label: faculty.label,
      value: faculty.value,
      checked: filters.some(filter => filter === faculty.value),
    };
  });
  return {
    name: 'Faculty',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: options,
    },
  };
};
